export default "__VITE_ASSET__hC1fBgkt__"